import React from "react";
import "./Kontakt.css";

function Kontakt() {
  return (
    <div className="kontakt-page">
      <section className="kontakt-hero">
        <h1 className="hp-h1 text-center" style={{ fontSize: "60px" }}>
          Pojďme probrat váš projekt.
        </h1>
        <p
          className="hp-sub text-center"
          style={{ maxWidth: "600px", margin: "0 auto" }}
        >
          Zjistíme, zda dává spolupráce smysl a jaký další krok je pro vás
          nejefektivnější.
        </p>

        <div className="kontakt-main">
          <div className="cta-primary-box text-center">
            <a
              href="https://cal.eu/andrea-liskova/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-large"
            >
              Rezervovat konzultaci
            </a>
            <p className="cta-sub">Preferujete zprávu? Napište mi níže.</p>
          </div>

          {/* TODO: Formulář pro odeslání e-mailu - dočasně skryt, napojení na e-mail bude provedeno později
                    <form className="kontakt-form" onSubmit={(e) => e.preventDefault()}>
                        <div className="form-group">
                            <label>Jméno</label>
                            <input type="text" placeholder="Vaše jméno" className="form-input" />
                        </div>

                        <div className="form-group">
                            <label>E-mail</label>
                            <input type="email" placeholder="vas@email.cz" className="form-input" />
                        </div>

                        <div className="form-group">
                            <label>S čím vám mohu pomoci?</label>
                            <textarea placeholder="Popište váš projekt..." className="form-textarea" rows="4"></textarea>
                        </div>

                        <button type="submit" className="btn btn-outline btn-submit">
                            Odeslat zprávu
                        </button>
                    </form>
*/}

          <div className="contact-details text-center">
            <p>Telefon: <a href="callto:+420605533201">+420 605 533 201</a></p>
            <p>E-mail: <a href="mailto:info@andrealiskova.cz">info@andrealiskova.cz</a></p>
          </div>

          <div className="final-text text-center">
            Spolupracuji s firmami, které chtějí mít marketing pod kontrolou.
          </div>
        </div>
      </section>
    </div>
  );
}

export default Kontakt;
